import React from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Plus, X, Info, Lock } from "lucide-react";
import { toast } from "sonner";

export const EmailListCard = ({ icon: Icon, title, subtitle, list, setList, value, setValue, testid, warning, locked = [] }) => {
  const add = () => {
    const v = value.trim().toLowerCase();
    if (!v) return;
    if (!v.includes("@")) { toast.error("Email non valida"); return; }
    if (list.includes(v)) { toast.error("Email già presente"); return; }
    setList([...list, v]); setValue("");
  };

  return (
    <div className="rounded-xl border border-border bg-card p-6">
      <div className="mb-1 flex items-center gap-2">
        <Icon className="h-5 w-5 text-primary" strokeWidth={1.75} />
        <h3 className="font-heading text-lg font-semibold">{title}</h3>
      </div>
      <p className="mb-4 text-sm text-muted-foreground">{subtitle}</p>

      <div className="mb-3 space-y-2">
        {list.length === 0 && <p className="text-xs text-muted-foreground">Nessuna email.</p>}
        {list.map((e) => (
          <div key={e} className="flex items-center justify-between rounded-lg border border-border px-3 py-2" data-testid={`${testid}-item-${e}`}>
            <span className="text-sm">{e}</span>
            {locked.includes(e) ? (
              <span className="flex items-center gap-1 text-[0.65rem] text-muted-foreground" title="Email base del team (configurazione server), sempre autorizzata" data-testid={`${testid}-locked-${e}`}>
                <Lock className="h-3 w-3" /> base
              </span>
            ) : (
              <button onClick={() => setList(list.filter((x) => x !== e))} data-testid={`${testid}-remove-${e}`}
                className="rounded p-1 text-muted-foreground transition-colors hover:bg-secondary hover:text-destructive">
                <X className="h-4 w-4" />
              </button>
            )}
          </div>
        ))}
      </div>

      <div className="flex gap-2">
        <Input placeholder="nome@email.com" value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }}
          data-testid={`${testid}-input`} />
        <Button variant="outline" onClick={add} data-testid={`${testid}-add-btn`}>
          <Plus className="h-4 w-4" />
        </Button>
      </div>

      {warning && (
        <div className="mt-3 flex items-start gap-2 rounded-lg border border-yellow-500/30 bg-yellow-500/5 px-3 py-2 text-xs text-yellow-500/90">
          <Info className="mt-0.5 h-3.5 w-3.5 shrink-0" /> {warning}
        </div>
      )}
    </div>
  );
};
